import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { BrManageContentButton } from '@bloomreach/react-sdk';
import { WebPage } from '@grandvisionhq/analytics';
import { monetate } from '@grandvisionhq/svc-monetate';
import '../containers/Accordion/Accordion.js';
import '../containers/Article/Article.js';
import '../containers/ArticleCollection/ArticleCollection.js';
import '../containers/Banner/Banner.js';
import '../containers/BannerCollection/BannerCollection.js';
import '../containers/BlogCollection/BlogCollection.js';
import '../containers/BlogOverview/BlogOverview.js';
import '../containers/BrandCollection/BrandCollection.js';
import '../containers/BrandList/BrandList.js';
import '../containers/Carousel/Carousel.js';
import { CmsComponentSlot } from '../containers/Slot/Slot.js';
import { useBrPageContext, useBrComponentContext } from '../context/context.js';
import '../context/configuration.js';
import '../containers/CountdownTimer/CountdownTimerDocument.js';
import '../containers/Iframe/Iframe.js';
import '../containers/LinkList/LinkList.js';
import '../containers/RecommendedProducts/RecommendedProducts.js';
import '../containers/RichText/RichTextDocument.js';
import '../containers/Video/Video.js';
import '../containers/Widget/Widget.js';
import '@grandvisionhq/common';
import '@grandvisionhq/elements';
import '@grandvisionhq/state';
import '@grandvisionhq/utils';
import '@bloomreach/spa-sdk';
import '@grandvisionhq/search';
import 'jsonpointer';
import { getPageSeo } from '../utils/get-page-seo.js';
import '../utils/http-client.js';
import '@grandvisionhq/lib-utils-html';
import '@grandvisionhq/content';
import '@grandvisionhq/graphql';
import '../operations/mutations/signup-promotion.js';
import '../operations/mutations/subscribe-newsletter.js';
import '../operations/mutations/subscribe-newsletter-opt-in.js';
import '@grandvisionhq/svc-tealium/events';
import { useBloomreachPageName } from '../hooks/use-bloomreach-page-name.js';
import '../hooks/use-breakpoint-visibility.js';
import '../containers/CountdownTimer/CountdownTimer.js';
import '../containers/Document/Document.js';
import '../containers/Faq/Faq.js';
import '@grandvisionhq/layout';
import '../containers/GroupedCards/GroupedCards.js';
import '@grandvisionhq/auth';
import '@grandvisionhq/frk-routing';
import '../containers/Heading/Heading.js';
import '../containers/IconList/IconList.js';
import '../containers/Newsletter/Newsletter.js';
import '../containers/NewsletterBanner/NewsletterBanner.js';
import '../containers/TryInStoreBanner/TryInStoreBanner.js';
import '../containers/NotificationBar/NotificationBar.js';
import '../containers/Olapic/Olapic.js';
import '../containers/PolicyBar/PolicyBar.js';
import '@grandvisionhq/commercetools';
import '@grandvisionhq/products';
import '../containers/Breadcrumbs/Breadcrumbs.js';
import '../containers/ProductCatalog/ProductCatalog.js';
import '../containers/Promotion/Promotion.js';
import '../containers/RecentlyViewedProducts/RecentlyViewedProducts.js';
import '../containers/RichText/RichText.js';
import { CmsSeo } from '../containers/Seo/Seo.js';
import '../containers/WidgetTrustedShop/WidgetTrustedShop.js';
import '../containers/Whitespace/Whitespace.js';
import '../containers/SpotlightedStores/SpotlightedStores.js';
import '../containers/FixedCta/FixedCta.js';
import '../containers/Button/Button.js';
import '../containers/GlobalContactForm/GlobalContactForm.js';
import 'classnames';
import '../containers/RowComponent/RowText/RowText.js';
import '../containers/RowComponent/RowProductListBySku/RowProductListBySku.js';
import { CmsPageLayout } from '../layouts/Page.js';
import CmsContentLayout from '../layouts/Content.js';
import CmsBlogLayout from '../layouts/Blog.js';

const isBlogArticle = (content)=>content.type === 'blogArticle'
;
const ContentPageType = ()=>{
    const page = useBrPageContext();
    const pageSeo = getPageSeo(page);
    const component = useBrComponentContext();
    var ref;
    const { document: documentRef  } = (ref = component === null || component === void 0 ? void 0 : component.getModels()) !== null && ref !== void 0 ? ref : {};
    const pageName = useBloomreachPageName();
    const document = page === null || page === void 0 ? void 0 : page.getContent(documentRef);
    const content = document === null || document === void 0 ? void 0 : document.getData();
    React.useEffect(()=>{
        monetate().commitMonetateEvent('other_page');
    }, []);
    if (!content) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, document && /*#__PURE__*/ React.createElement(BrManageContentButton, {
        content: document
    }), isBlogArticle(content) ? /*#__PURE__*/ React.createElement(CmsBlogLayout, {
        content: content
    }) : /*#__PURE__*/ React.createElement(CmsContentLayout, {
        content: content,
        pageName: pageName || '',
        hasBreadcrumbs: true
    }), pageSeo && content && /*#__PURE__*/ React.createElement(WebPage, {
        pageType: "Information",
        url: pageSeo.canonicalUrl,
        name: content.title,
        description: content.summary
    }));
};
const CmsContentPage = (props)=>{
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(CmsSeo, null), /*#__PURE__*/ React.createElement(CmsPageLayout, swcHelpers.extends({}, props), /*#__PURE__*/ React.createElement(CmsComponentSlot, {
        path: "main/content"
    }, /*#__PURE__*/ React.createElement(ContentPageType, null))));
};

export { CmsContentPage as default };
//# sourceMappingURL=content.js.map
